import { AnyExtension } from '@tiptap/core';
import Text from '@tiptap/extension-text';
import BulletList from '@tiptap/extension-bullet-list';
import OrderedList from '@tiptap/extension-ordered-list';
import ListItem from '@tiptap/extension-list-item';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Strike from '@tiptap/extension-strike';
import Underline from '@tiptap/extension-underline';
import DropCursor from '@tiptap/extension-dropcursor';
import GapCursor from '@tiptap/extension-gapcursor';
import HardBreak from '@tiptap/extension-hard-break';
import Heading from '@tiptap/extension-heading';
import Blockquote from '@tiptap/extension-blockquote';
import { Link } from '../../../tiptap/extensions/link/link';
import {
  Table,
  TableCell,
  TableHeader,
  TableRow,
} from '@duke-hq/ui/components/DukeTiptapEditor/Extensions/table';
import Paragraph from '@tiptap/extension-paragraph';
import Placeholder from '@tiptap/extension-placeholder';
import Document from '@tiptap/extension-document';
import { FlowDBlock } from '../../tiptap/flowDBlock/flowDBlock';
import { ResizableMediaExtension } from '../../tiptap/resizableMedia/ResizableMediaExtension';
import { FileExtension } from '../../tiptap/FileTTComponent';

export const getBlockExtensions = (): AnyExtension[] => {
  return [
    // Necessary
    Document,
    FlowDBlock,
    Paragraph,
    Text,
    DropCursor.configure({
      width: 2,
      class: 'notitap-dropcursor',
      color: 'skyblue',
    }),
    GapCursor,
    // History (Cmd+Z within the editor) is intentionally omitted: the flow
    // graph's undo stack is the single owner of undo/redo, so a bubble edit and
    // a structural edit both revert through the same Cmd+Z. Re-adding History
    // here would let ProseMirror swallow Cmd+Z before the graph stack sees it.
    HardBreak,
    // Shows a prompt in an empty message. includeChildren makes the decoration
    // reach the paragraph inside the dBlock wrapper (without it the is-empty
    // class lands on the wrapper div, not the <p>, and the placeholder CSS never
    // matches). Paired with a min-height on the paragraph (the editor's scoped
    // `.tiptap` styles) so an otherwise zero-height empty line still shows a caret.
    Placeholder.configure({
      placeholder: 'Type a message...',
      includeChildren: true,
    }),

    // marks
    Bold,
    Italic,
    Strike,
    Underline,
    Link.configure({
      autolink: true,
      linkOnPaste: true,
      openOnClick: false,
    }),
    Blockquote,

    // Node
    ListItem,
    BulletList,
    OrderedList,
    Heading.configure({
      levels: [1, 2, 3],
    }),

    //FILE
    FileExtension,
    // Table
    Table,
    TableRow,
    TableHeader,
    TableCell,
    // Resizable Media
    ResizableMediaExtension,
  ];
};
